import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

require("es6-promise").polyfill();
const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: (state) => ({
    navigation: state.navigation,
    dataRow: state.dataRow,
  }),
});

Vue.use(Vuex);
const state = {
  dataRow: {},
};

const getters = {
  dataRow: (state) => {
    return state.dataRow;
  },
};

const mutations = {
  SET_DATAROW: (state, newRow) => {
    state.dataRow = newRow;
  },
};

const actions = {
  setDataRow: ({ commit, state }, newRow) => {
    commit("SET_DATAROW", newRow);
    return state.dataRow;
  },
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [vuexLocal.plugin],
  getters,
});
